import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import TipoProyectoForm from '../TipoProyectoForm';

function TipoProyectoEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <TipoProyectoForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </TipoProyectoForm>
    </Edit>
  );
}

export default TipoProyectoEdit;
